import * as React from "react"
import { Box, Link } from "@mui/material"
import { FlagsIconSeeker, IconSeeker } from "@ui-seeker/core"


export default function LabelCountry({ country, label, url=null, sx={} }) {
    if (!url) return <LabelCountryLinkness country={country} label={label} sx={sx} />

    return <Link href={url} target="_blank">
        <LabelCountryLinkness country={country} label={label} sx={sx} showIcon />
    </Link>
}

const LabelCountryLinkness = ({ country, label, sx, showIcon=false }) => <>
    <Box component="span" sx={{ display: 'flex', alignItems: 'center', gap: .5, ...sx }}>
        <FlagsIconSeeker countryName={country} />
        <Box component="span">
            {label}
        </Box>
        {showIcon && <IconSeeker icon={'up-right-from-square'} sx={{ mr: 0.5, margin: .5, color: 'primary.main'}}/>}
    </Box>
</>